// sendBodyFont.ts — ausgehender Mail-Body in der App-Sende-Schrift.
//
// Ist-Problem: Der Compose-Editor setzt die Schrift zwar per Container-`style`,
// diese Deklaration steckt aber NICHT im extrahierten `innerHTML`, das gesendet
// wird. Ohne Schriftangabe rendern empfangende Clients (Outlook & Co.) den Body
// in ihrer je eigenen Standardschrift.
//
// Soll: den Sende-Body EINMAL in einen Container mit der App-Sende-Schrift
// (Times New Roman, 11pt — identisch zum Editor) wrappen, sodass die Mail bei
// allen Empfängern einheitlich erscheint. Eine eingebettete Signatur bleibt
// UNANGETASTET: ihre eigenen Inline-Styles (font-family/-size) überschreiben die
// vom Wrapper vererbte Schrift, und wir schreiben das Signatur-Markup nicht um.

/** App-Sende-Schrift für den gesendeten Mail-Body (identisch zum Editor). */
export const SEND_BODY_FONT_STYLE =
  "font-family: 'Times New Roman', Times, serif; font-size: 11pt;";

/**
 * Wrappt den (bereits sanitisierten) ausgehenden HTML-Body in einen
 * `<div>`-Container mit der App-Sende-Schrift (Times New Roman, 11pt). Der
 * Server-Sanitizer (`sanitizeMailHtml`) lässt `<div>` samt `style`-Attribut
 * (font-family/-size) passieren, sodass die Deklaration die gesendete Mail
 * erreicht.
 *
 * Leerer/whitespace-only Input bleibt unverändert (kein leerer Style-Container
 * im Wire-Body).
 */
export function wrapSendBodyFont(html: string | null | undefined): string {
  const value = html ?? "";
  if (!value.trim()) return value;
  return `<div style="${SEND_BODY_FONT_STYLE}">${value}</div>`;
}
